module.exports = __webpack_public_path__ + "static/img/r-2.a2f969c9.png";